import buyer from './buyer.json';

export default {
  buyer,
};
